export default {
      id: "drag-small-usage",
      viewBox: "0 0 9 12",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#drag-small",
      toString: function () {
        return this.url;
      }
    }